import { removeEmpty } from "../utils/filters/shared";

type BulletedListProps = {
  values: string[];
  className?: string;
  emptyMsg?: string;
};

function BulletedList({
  values,
  className,
  emptyMsg,
}: BulletedListProps) {

  values = removeEmpty(values);

  if ((!values || values.length === 0) && emptyMsg) {
    return (
      <ul>
        <li className={className} style={{fontFamily: 'Trebuchet MS', color: '#1A103F'}}>{emptyMsg}</li>
      </ul>
    );
  }

  return (
    <ul>
      {values && values
        .map((val, idx) => (
          <li key={idx} className={className} style={{fontFamily: 'Trebuchet MS', color: '#1A103F'}}>
            {`${val}`}
          </li>
        ))}
    </ul>
  );
}

export default BulletedList;
